<template>
  <div class="home">
    <top class="home-top"> </top>

    <div class="home-content">
      <left class="left"></left>
      <center class="center"></center>
      <right class="right"> </right>
    </div>
  </div>
</template>

<script>
import center from "./components/center.vue";
import left from "./components/left.vue";
import right from "./components/right.vue";
import top from "./components/top.vue";
export default {
  components: {
    left,
    right,
    top,
    center,
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.home {
  width: 100%;
  height: 100%;
  color: #fff;
  background-color: #111944;

  .home-top {
    height: 80px;
  }

  .home-content {
    display: flex;
    height: calc(100% - 90px); // justify-content: space-between;

    .left {
      width: 22%;
      min-width: 340px;
      height: 100%;
    }

    .center {
      flex: 1;
      height: 100%;
    }

    .right {
      width: 22%;
      min-width: 340px;

      height: 100%;
    }
  }
}
</style>